import FieldBase from './FieldBase';
import { IFieldBaseProperties } from './interfaces';
import FieldTypes from './enums/FieldTypes';

interface IFileFieldProperties extends IFieldBaseProperties {
  onChange: (event: React.FormEvent<HTMLInputElement>) => void;
  allowedFileTypes?: string[]
}

const FileField = function(props: IFileFieldProperties) {
    const {
        id,
        onChange,
        required,
        allowedFileTypes,
        label
    } = props;
    let acceptProps: {accept?: string} = {};
    let fieldLabel = label;
    if (allowedFileTypes != undefined && allowedFileTypes.length > 0) {
        acceptProps.accept = allowedFileTypes.join(",");
        fieldLabel += ` (${acceptProps.accept})`;
    }
    return (
        <FieldBase key={id + "_field"} {...props} label={fieldLabel} type={FieldTypes.FILE_CUSTOM}>
            <input 
                key={id + "_file"} 
                type="file" 
                className="hcs-file__input w-full " 
                id={id} 
                name={id} 
                onChange={onChange}
                required={required}
                {...acceptProps} />
        </FieldBase>
    );
}

export default FileField;